import StepProgressIndicator from './StepProgressIndicator';
import { cEl } from '../../../../util';
import { getTestList } from '../constants';

function ProgressBar({ key, title, subTitle, progressStatus }) {
    const testList = getTestList();
    const testIndex = testList.findIndex(testInfo => testInfo.key === key);
    const progressBar = cEl('div');
    progressBar.classList.add('test-progress-bar');

    const titleEl = cEl('div');
    titleEl.classList.add('title');
    titleEl.innerHTML = title;

    const subTitleEl = cEl('div');
    subTitleEl.classList.add('sub-title');
    subTitleEl.innerHTML = subTitle ?? `Step ${testIndex + 1}`;

    progressBar.append(subTitleEl, titleEl);

    if (progressStatus) {
        progressBar.appendChild(
            StepProgressIndicator({
                progressStatus: testList
                    .filter(testInfo => testInfo.progressStatus)
                    .map((testInfo, i) => testIndex >= i),
            }),
        );
    }

    return progressBar;
}

export default ProgressBar;
